import { render, staticRenderFns } from "./PageInboxBase.vue?vue&type=template&id=5071436d&"
import script from "./PageInboxBase.vue?vue&type=script&lang=js&"
export * from "./PageInboxBase.vue?vue&type=script&lang=js&"
import style0 from "./PageInboxBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports